export enum Permiso {

	/* #region MarcasDispositivos */
	ConsultarMarcasDispositivos = "1",
	AgregarMarcaDispositivo = "2",
	ActualizarMarcaDispositivo = "3",
	EliminarMarcaDispositivo = "4",
	/* #endregion */

	/* #region MarcasVehiculos */
	ConsultarMarcasVehiculos = "5",
	AgregarMarcaVehiculo = "6",
	ActualizarMarcaVehiculo = "7",
	EliminarMarcaVehiculo = "8",
	/* #endregion */

	/* #region ModelosDispositivos */
	ConsultarModelosDispositivos = "9",
	AgregarModeloDispositivo = "10",
	ActualizarModeloDispositivo = "11",
	EliminarModeloDispositivo = "12",
	/* #endregion */

	/* #region ModelosVehiculos */
	ConsultarModelosVehiculos = "13",
	AgregarModeloVehiculo = "14",
	ActualizarModeloVehiculo = "15",
	EliminarModeloVehiculo = "16",
	/* #endregion */

	/* #region Sims */
	ConsultarSims = "17",
	AgregarSim = "18",
	ActualizarSim = "19",
	EliminarSim = "20",
	/* #endregion */

	/* #region Dispositivos */
	ConsultarDispositivos = "21",
	AgregarDispositivo = "22",
	ActualizarDispositivo = "23",
	EliminarDispositivo = "24",
	/* #endregion */

	/* #region Vehiculos */
	ConsultarVehiculos = "25",
	AgregarVehiculo = "26",
	ActualizarVehiculo = "27",
	EliminarVehiculo = "28",
	ConsultarGaleria = "178",
	/* #endregion */

	/* #region Clientes */
	ConsultarClientes = "29",
	AgregarCliente = "30",
	ActualizarCliente = "31",
	EliminarCliente = "32",
	/* #endregion */

	/* #region Usuarios */
	ConsultarUsuarios = "33",
	AgregarUsuario = "34",
	ActualizarUsuario = "35",
	EliminarUsuario = "36",
	AsignarVehiculosUsuario = "37",
	/* #endregion */

	/* #region Mapa */
	VisualizarVehiculos = "38",
	VisualizarDispositivosMoviles = "39",
	VisualizarMedidores = "40",
	VisualizarLuminarias = "41",
	VisualizarVendedores = "42",
	VisualizarClientes = "43",
	VisualizarGeocercas = "44",
	VisualizarPuntosInteres = "45",
	VisualizarEtiquetas = "46",
	VisualizarGaleria = "47",
	AgregarGeocerca = "48",
	ActualizarGeocerca = "49",
	EliminarGeocerca = "50",
	AgregarPuntoInteres = "51",
	ActualizarPuntoInteres = "52",
	EliminarPuntoInteres = "53",
	MostrarAlertasGenerales = "61",
	MostrarSemaforo = "62",
	/* #endregion */

	/* #region Dashboards */
	ConsultarDashboardVehiculos = "54",
	ConsultarDashboardSensores = "55",
	ConsultarDashboardCRM = "56",
	/* #endregion */

	/* #region Mensajes */
	ConsultarMensajes = "57",
	AgregarMensaje = "58",
	ActualizarMensaje = "59",
	EliminarMensaje = "60",
	/* #endregion */

	/* #region Medidores */
	AgregarMarcaMedidor = "63",
	ActualizarMarcaMedidor = "64",
	ConsultarMarcaMedidor = "65",
	EliminarMarcaMedidor = "66",
	AgregarModeloMedidor = "67",
	ActualizarModeloMedidor = "68",
	ConsultarModeloMedidor = "69",
	EliminarModeloMedidor = "70",
	AgregarMedidor = "71",
	ActualizarMedidor = "72",
	ConsultarMedidores = "73",
	EliminarMedidores = "74",
	VisualizarEtiquetasMedidores = "87",
	/*#endregion */

	/*#region Micromedidores */
	AgregarMarcaMicromedidores = "75",
	ActualizarMarcaMicromedidores = "76",
	ConsultarMarcaMicromedidores = "77",
	EliminarMarcaMicromedidores = "78",
	AgregarModeloMicromedidores = "79",
	ActualizarModeloMicromedidores = "80",
	ConsultarModeloMicromedidores = "81",
	EliminarModeloMicromedidores = "82",
	AgregarMicromedidor = "83",
	ActualizarMicromedidor = "84",
	EliminarMicromedidor = "85",
	ConsultarMicromedidor = "86",
	/*#endregion */

	/**#region telefonos */
	AgregarTelefono = "88",
	ActualizarTelefono = "89",
	EliminarTelefono = "90",
	ConsultarTelefono = "91",
	ConsultarMarcaTelefonos = "92",
	EliminarMarcaTelefonos = "93",
	AgregarMarcaTelefonos = "94",
	ActualizarMarcaTelefonos = "95",
	ConsultarModeloTelefonos = "96",
	EliminarModeloTelefonos = "97",
	/**#endregion */

	/*#region activos*/
	AgregarActivo = "100",
	ActualizarActivo = "101",
	ConsultarActivo = "102",
	EliminarActivo = "103",
	ConsultarMarcaActivo = "104",
	EliminarMarcaActivo = "105",
	AgregarMarcaActivo = "106",
	ActualizarMarcaActivo = "107",
	ConsultarModeloActivo = "108",
	EliminarModeloActivo = "109",
	AgregarModeloActivo = "110",
	ActualizarModeloActivo = "111",
	/**#endregion */

	/*Region Productos */
	AgregarProducto = "112",
	ConsultarProducto = "113",
	ActualizarProducto = "114",
	EliminarProducto = "115",

	ConsultarAlertados = "116",
	ConsultarTransmisiones = "117",
	ConsultarSinTransmision = "118",
	GenerarPDFAlertados = "127",

	AgregarModulo = "119",
	ActualizarModulo = "120",
	EliminarModulo = "121",
	ConsultarModulo = "122",

	AgregarPermiso = "123",
	ActualizarPermiso = "124",
	ConsultarPermiso = "125",
	EliminarPermiso = "126",

	VisualizarVideos = "128",

	ReporteCentinela = "129",
	AlertaSecundaria = "130",
	Alerta = "131",
	AlertaSalidaGeocerca = "132",
	AlertaBateriaBaja = "98",
	AlertaEnergia = "99",

	ReportePosiscion = "133",
	ReporteVelocidad = "134",
	ReporteDistancia = "135",
	ReporteUltimaTransmision = "136",
	ConsultarReportes = "137",
    EnvioCorreo="138",
	CategoriasGeocerca="139",
	VisualizarMDVR = "140",

	VisaulizarMaqueta = "141",
	ReporteProductosCliente = "142",
	MostrarAlertasDVR = "143",
	ConsultarAlumbrado = "144",
	ConsultarTerminalLectora = "145",

	ConsultarReporteInicioFin = "146",

	AgregarTerminalLectora = "147",
	ActualizarTerminalLectora = "148",
	EliminarTerminalLectora = "149",
	VisualizarLectoras = "150",

	VisualizarReporteParadas = "Reporte Paradas",
	ClienteCostaRica = "152",

	VisualizarVehiculosUsuario = "153",
	VisualizarFacturacion = "154",

	/***Pasajeros */
	SaldoPasajeros="157",
	ConsultarPasajeros="156",
	ListaSaldos ="159",

	/***Sincronizador */
	ConsultarSincronizador = "160",

	/**Operadores */
	AgregarOperador ="161",
	ConsultarOperador="162",
	EliminarOperador="163",
	ActualizarOperador="164",
	ConsultaMantenimiento="165",
	/**Inventario*/
	ConsultaInventario="166",

	/*Garzas*/
	ConsultarGarza = "167",

	/*LoRaWAN*/
	ConsultarDatosLoRaWAN = "168",


	/**Portatiles */
	AgregarPortatil="169",
	ActualizarPortatil = "170",
	ConsultarPortatil="171",
	EliminarPortatil ="172",
	VisualizarPortatiles="173",

	/**Mantenimiento */
	ConsultaServicios="174",

	/**inspeccion */
	ConsultadeRegistros ="176",

	/**Bitácora */
	Bitácora = "177",

	/**gasolina */
	AsignacionCombustible="179",

	/**Panel ciudadano */
	AlertaPanelCiudadano="180",
	AgregarPanel="181",
	ActualizarPanel="182",
	ConsultarPanel="183",
	EliminarPanel="184",
}
